import { BackgroundCheckStatus, BackgroundCheckType } from '@/backend/features/background-check/types';
import { FormViewer } from '@juvare/common-form-ui/FormViewer';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { Divider, Typography } from '@mui/material';
import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface ManualBackgroundCheckStatusSelectProps {
    backgroundCheckStatus: string | undefined;
    backgroundCheckType: string | undefined;
    backgroundCheckProcess: string | undefined;
    setBackgroundCheckStatus: (status: BackgroundCheckStatus) => void;
    isFormValid: boolean;
}

const getManualBackgroundCheckStatusFormConfig = (t: TFunction<'rms'>) => ({
    type: 'form',
    children: [
        {
            type: 'form.select',
            key: 'status',
            label: t('backgroundCheck.labels.backgroundCheckStatus'),
            validate: {
                required: true,
            },
            valueProvider: {
                type: 'backgroundCheckEnabledStatuses',
                paramsFromFormData: 'type',
            },
            allowInvalidValues: true,
        },
    ],
});

export const ManualBackgroundCheckStatusSelect: React.FC<ManualBackgroundCheckStatusSelectProps> = ({
    backgroundCheckStatus,
    backgroundCheckType,
    backgroundCheckProcess,
    setBackgroundCheckStatus,
    isFormValid,
}) => {
    const { t } = useTranslation('rms');
    const { backgroundCheckConfig } = useSelector(getSettings);

    const didNotConsent: BackgroundCheckStatus = 'didNotConsent';
    const formIncomplete: BackgroundCheckStatus = 'formIncomplete';

    if (
        backgroundCheckProcess === 'manual' &&
        backgroundCheckStatus !== didNotConsent &&
        backgroundCheckStatus !== formIncomplete &&
        isFormValid
    ) {
        return (
            <>
                <Divider sx={{ mt: 2 }} />
                <Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: 14,
                        my: 2,
                    }}
                >
                    {t('backgroundCheck.messages.chooseBackgroundCheckStatus', {
                        type: backgroundCheckConfig.type[backgroundCheckType as BackgroundCheckType].label || backgroundCheckType,
                    })}
                </Typography>
                <FormViewer
                    config={getManualBackgroundCheckStatusFormConfig(t)}
                    data={{
                        type: backgroundCheckType,
                        status: backgroundCheckStatus,
                    }}
                    onDataChange={(newData) => {
                        setBackgroundCheckStatus(newData.data.status);
                    }}
                />
            </>
        );
    }
    return;
};
